import { ElementRef } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

export type ElementWidthResize = {
	width$: Observable<number>;
	disconnect: () => void;
};

/** Observe host element width via ResizeObserver. Call disconnect on destroy. */
export function observeElementWidth(el: ElementRef<HTMLElement> | HTMLElement): ElementWidthResize {
	const host = el instanceof ElementRef ? el.nativeElement : el;
	const width$ = new BehaviorSubject<number>(0);
	const observer = new ResizeObserver((entries) => {
		width$.next(entries[0]?.contentRect.width ?? 0);
	});
	observer.observe(host);
	return {
		width$: width$.asObservable(),
		disconnect: () => {
			observer.disconnect();
			width$.complete();
		},
	};
}
